import { useQuery } from "react-query";
import { useSnackbar } from "./useSnackbar";
import { useAuth } from "./useAuth";
import MainUseCase from "../usecases/MainUseCase";
import MainApi from "../api/MainApi";
import { useLoading } from "./useLoading";
import { useEffect } from "react";
import { ViewPaymentRequest, ViewPaymentResult } from "../domain/entity/Main";

export function useViewPayment({merchantEmail, merchantName, merchantPhoneNumber, totalAmount}: ViewPaymentRequest | any) {
  const { showSnackbar } = useSnackbar();
  const { setExpired } = useAuth();
  const { showLoading } = useLoading();

  const repository = new MainUseCase(new MainApi());

  const {
    data: payment,
    isFetching: isLoadingViewPayment,
    refetch: viewPayment,
    isError,
  } = useQuery({
    queryKey: ["viewPayment"],
    queryFn: () => repository.getViewPayment({merchantEmail, merchantName, merchantPhoneNumber, totalAmount}),
    enabled: false, 
    retry: false,
    onSuccess: (results: ViewPaymentResult) => {
      // console.log('results payment', results)
      if (results.responseCode === "20000") {
        window.open(results.paymentUrl, "_blank");
      } else {
        showSnackbar(results?.responseMessage || "Error - Terjadi Kendala");
      }
    },
    onError: (error: any) => {
      if (
        error.response === undefined ||
        error.response.data === "Read timed out" ||
        error.response.status === 500
      ) {
        showSnackbar("Error - Terjadi Kendala");
      } else if (
        error.response.data !== undefined &&
        error.response.status !== 401
      ) {
        showSnackbar(error.response.data.responseMessage);
      } else if (error.response.status === 401) {
        setExpired(true);
      } else {
        showSnackbar("Error - Terjadi Kendala");
      }
    },
  });

  useEffect(() => {
      showLoading(isLoadingViewPayment);
    }, [isLoadingViewPayment]);

  return { viewPayment, isLoadingViewPayment, isError };
}
